// extracted by mini-css-extract-plugin
module.exports = {"fondo":"Top__fondo__3Kvto","table":"Top__table__3qY2C","tableHeader":"Top__tableHeader__2L2o0"};